import { Injectable } from '@angular/core';
import { SecurityService } from '../../../services/security.service';

import { Account } from '../../../domain/account.domain';
import { SymbolType } from '../../../domain/symbol.domain';

const EQUITIES = ['EQUITY', 'STOCK', 'ETF'];

const USER_PERMISSION_SECURITY_MAP = {
  EQUITY: 'EQUITY_TRADING',
  STOCK: 'EQUITY_TRADING',
  ETF: 'EQUITY_TRADING',
  OPTION: 'OPTION_TRADING',
  MUTUALFUND: 'MUTUAL_FUND_TRADING',
  // TODO: Clean up mutual fund type should be consistent
  MUTUAL_FUND: 'MUTUAL_FUND_TRADING',
  GIC: 'GIC_TRADING',
  FIXED_INCOME: 'FIXED_INCOME_TRADING'
};

const ACCOUNT_PERMISSION_SECURITY_MAP = {
  EQUITY: 'CAN_TRADE_STOCK',
  STOCK: 'CAN_TRADE_STOCK',
  ETF: 'CAN_TRADE_STOCK',
  OPTION: 'CAN_TRADE_OPTION',
  MUTUALFUND: 'CAN_TRADE_MUTUALFUND',
  // TODO: Clean up mutual fund type should be consistent
  MUTUAL_FUND: 'CAN_TRADE_MUTUALFUND',
  FIXED_INCOME: 'CAN_TRADE_FIXEDINCOME',
  GIC: 'CAN_TRADE_GIC'
};

@Injectable({
  providedIn: 'root'
})
export class BuySellService {
  constructor(private securityService: SecurityService) {
  }

  /**
   * hasPermission
   * Checks if user has permission for a specific type of order
   *
   * @param type
   * @return
   */
  hasPermission(type: SymbolType): boolean {
    return (EQUITIES.indexOf(type) > -1 && this.securityService.hasPermission('EQUITY_TRADING')) ||
      (type === SymbolType.OPTION && this.securityService.hasPermission('OPTION_TRADING')) ||
      (type === SymbolType.MUTUALFUND && this.securityService.hasPermission('MUTUAL_FUND_TRADING')) ||
      (type === SymbolType.FIXED_INCOME && this.securityService.hasPermission('FIXED_INCOME_TRADING')) ||
      (type === SymbolType.GIC && this.securityService.hasPermission('GIC_TRADING'));
  }

  /**
   * method
   *
   * @param
   *      {string} Security Type
   *      {object} account Account Object. Optional parameter, if not defined than only user level permission is checked
   *
   * @return
   *      true if user has proper permission to trade specified security type.
   *      User and account level permissions are checked.
   *      Account level permission is ignored if account is not passed as a parameter.
   */
  isBuySellEnabled(type: SymbolType, account?: Account): boolean {
    const userPermission = USER_PERMISSION_SECURITY_MAP[type];
    let accountPermission: string;
    let result = false;
    if (account !== undefined && account !== null) {
      accountPermission = ACCOUNT_PERMISSION_SECURITY_MAP[type];
      result = Boolean(userPermission) &&
        this.securityService.hasPermission(userPermission) &&
        this.securityService.hasAccountPermission(account, accountPermission);
    } else {
      result = Boolean(userPermission) && this.securityService.hasPermission(userPermission);
    }
    return result;
  }
}
